import React, { useEffect, useState } from "react";
import { collection, getDocs, addDoc } from "firebase/firestore";
import { db } from "./firebase";
import TutorLayout from "./TutorLayout";

function SetHomeworkPage() {
  const [title, setTitle] = useState("");
  const [notes, setNotes] = useState("");
  const [dueDate, setDueDate] = useState("");
  const [selectedStudent, setSelectedStudent] = useState("");
  const [students, setStudents] = useState([]);
  const [assignments, setAssignments] = useState([]);
  const [selectedAssignments, setSelectedAssignments] = useState([]);
  const [googleResources, setGoogleResources] = useState([{ name: "", url: "" }]);

  useEffect(() => {
    const fetchData = async () => {
      const studentSnap = await getDocs(collection(db, "users"));
      const students = studentSnap.docs
        .map((doc) => ({ id: doc.id, ...doc.data() }))
        .filter((u) => u.role === "student");
      setStudents(students);

      const draftSnap = await getDocs(collection(db, "assignments"));
      const drafts = draftSnap.docs
        .map((doc) => ({ id: doc.id, ...doc.data() }))
        .filter((a) => a.isDraft);
      setAssignments(drafts);
    };
    fetchData();
  }, []);

  const toggleAssignment = (id) => {
    setSelectedAssignments((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };

  const handleSaveHomework = async () => {
    if (!title || !selectedStudent) {
  alert("Please enter a title and select a student.");
  return;
}


    try {
      await addDoc(collection(db, "homework"), {
        title,
        notes,
        studentUID: selectedStudent,
        assignments: selectedAssignments,
        googleResources: googleResources.filter((r) => r.name && r.url),
        dueDate: dueDate || null,
        createdAt: new Date().toISOString(),
      });

      alert("✅ Homework set successfully!");
      setTitle("");
      setNotes("");
      setSelectedStudent("");
      setSelectedAssignments([]);
      setGoogleResources([{ name: "", url: "" }]);
      setDueDate("");
    } catch (err) {
      console.error("Error saving homework:", err);
      alert("Something went wrong.");
    }
  };

  return (
    <TutorLayout>
      <div style={{ padding: "2rem", maxWidth: "800px", margin: "0 auto" }}>
        <h2>📝 Set Homework</h2>

        <label>👤 Select Student:</label>
        <select
          value={selectedStudent}
          onChange={(e) => setSelectedStudent(e.target.value)}
          style={{ width: "100%", padding: "10px", marginBottom: "1rem" }}
        >
          <option value="">-- Select Student --</option>
          {students.map((s) => (
            <option key={s.id} value={s.uid}>
              {s.displayName || s.email}
            </option>
          ))}
        </select>

        <label>📌 Title:</label>
        <input
          type="text"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          placeholder="e.g. Fractions Homework"
          style={{ width: "100%", padding: "10px", marginBottom: "1rem" }}
        />

        <label>📝 Notes:</label>
        <textarea
          value={notes}
          onChange={(e) => setNotes(e.target.value)}
          placeholder="Optional notes..."
          style={{ width: "100%", padding: "10px", marginBottom: "1rem" }}
        />

        <label>📅 Due Date:</label>
        <input
          type="date"
          value={dueDate}
          onChange={(e) => setDueDate(e.target.value)}
          style={{ width: "100%", padding: "10px", marginBottom: "1.5rem" }}
        />

        <div style={{ marginBottom: "1.5rem" }}>
          <h4>📎 Google Drive Resources</h4>
          {googleResources.map((res, idx) => (
            <div key={idx} style={{ display: "flex", gap: "1rem", marginBottom: "0.5rem" }}>
              <input
                type="text"
                placeholder="Name"
                value={res.name}
                onChange={(e) => {
                  const copy = [...googleResources];
                  copy[idx].name = e.target.value;
                  setGoogleResources(copy);
                }}
              />
              <input
                type="text"
                placeholder="URL"
                value={res.url}
                onChange={(e) => {
                  const copy = [...googleResources];
                  copy[idx].url = e.target.value;
                  setGoogleResources(copy);
                }}
              />
            </div>
          ))}
          <button onClick={() => setGoogleResources([...googleResources, { name: "", url: "" }])}>
            ➕ Add Resource
          </button>
        </div>

        <div style={{ marginBottom: "2rem" }}>
          <h4>📋 Select Saved Assignments</h4>
          {assignments.length === 0 ? (
            <p>No saved assignments found.</p>
          ) : (
            <ul style={{ listStyle: "none", paddingLeft: 0 }}>
              {assignments.map((a) => (
                <li key={a.id} style={{ marginBottom: "0.5rem" }}>
                  <label>
                    <input
                      type="checkbox"
                      checked={selectedAssignments.includes(a.id)}
                      onChange={() => toggleAssignment(a.id)}
                    /> {a.title || "(Untitled Assignment)"}
                  </label>
                </li>
              ))}
            </ul>
          )}
        </div>

        <button
          onClick={handleSaveHomework}
          style={{ padding: "0.8rem 1.5rem", backgroundColor: "#00b894", color: "white", border: "none", borderRadius: "8px", fontWeight: "600" }}
        >
          💾 Save Homework
        </button>
      </div>
    </TutorLayout>
  );
}

export default SetHomeworkPage;